import { type CartFormValues } from '@cart-services/zod-schema/cartFormSchema'
import { FormProvider, type FormProviderProps } from 'react-hook-form'

export const CartFormProvider = (props: FormProviderProps<CartFormValues>) => {
  return <FormProvider {...props} />
}
